module.exports = __webpack_public_path__ + "static/media/art2.f32adba5.png";